import { Confirmation } from './commonAnswersTypes.js';

export enum Frequency {
  often = 'often',
  sometimes = 'sometimes',
  never = 'never',
}

export enum Agreement {
  stronglyAgree = 'strongly-agree',
  agree = 'agree',
  neutral = 'neutral',
  disagree = 'disagree',
  stronglyDisagree = 'strongly-disagree',
}

export enum Likelihood {
  veryLikely = 'very-likely',
  likely = 'likely',
  neutral = 'neutral',
  unlikely = 'unlikely',
  veryUnlikely = 'very-unlikely',
}

export enum ChildcareSituation {
  affordNeeds = 'afford-needs',
  missedWork = 'missed-work',
  supbarChildcare = 'subpar-childcare',
  none = 'none',
}

export enum EmergencyCategories {
  food = 'food',
  housing = 'housing',
  childcare = 'childcare',
  transportation = 'transportation',
  health = 'health',
  safety = 'safety',
  learning = 'learning',
  none = 'none',
}

export enum FoodChalleges {
  insufficientFunds = 'insufficient-funds',
  borrowedFunds = 'borrowed-funds',
  wentHungry = 'went-hungry',
  attendedEventForFood = 'attended-event-for-food',
  unhealthyFood = 'unhealthy-food',
  none = 'none',
}

export enum HousingSituation {
  rentRaised = 'rent-raised',
  behindOnRent = 'behind-on-rent',
  struggledToPay = 'struggled-to-pay',
  movedOften = 'moved-often',
  shortedBills = 'shorted-bills',
  temporaryHousing = 'temporary-housing',
  compactLiving = 'compact-living',
  none = 'none',
}

export enum PhysiologicChallengeFrequency {
  none = 'none',
  oneOrTwoDays = '1-2 days',
  threeToFiveDays = '3-5 days',
  sixOrMoreDays = '6 or more days',
}

export enum PhysiologicSituation {
  physicalAssault = 'physical-assault',
  sexualAssault = 'sexual-assault',
  dacaEligible = 'daca-eligible',
  none = 'none',
}

export enum PhysiologicSituationPastMonth {
  avoidedDoctor = 'avoided-doctor',
  unexpectedMedicalExpense = 'unexpected-medical-expense',
  leftUnsafeHousing = 'left-unsafe-housing',
  skippedMedication = 'skipped-medication',
  none = 'none',
}

export enum SleepingSituation {
  campusHousing = 'campus-housing',
  fratHouse = 'frat-house',
  apartment = 'apartment',
  apartmentWithFamily = 'apartment-with-family',
  shelter = 'shelter',
  camper = 'camper',
  couchSurfing = 'couch-surfing',
  hotel = 'hotel',
  independentLiving = 'independent-living',
  groupHome = 'group-home',
  treatmentCenter = 'treatment-center',
  outdoors = 'outdoors',
  outdoorsCovered = 'outdoors-covered',
  none = 'none',
}

export enum TransportationSituation {
  carRepair = 'car-repair',
  carStolen = 'car-stolen',
  licenseRevoked = 'license-revoked',
  bikeStolen = 'bike-stolen',
  insufficientFunds = 'insufficient-funds',
  behindOnPayments = 'behind-on-payments',
  none = 'none',
}

export enum LearningSituation {
  cannotAffordBooks = 'cannot-afford-books',
  cannotAffordSupplies = 'cannot-afford-supplies',
  computerBroken = 'computer-broken',
  none = 'none',
}

export interface EmergencyAidApplicationAnswers {
  name?: string;
  schoolName?: string;
  graduationDate?: Date;
  zipCode?: string;
  hasDependants?: Confirmation;
  youngestDependantAge?: number;
  basicInfoIntroCompleted?: boolean;
  basicInfoSummaryCompleted?: boolean;
  financialChallengesIntroCompleted?: boolean;
  facingFinancialChallenges?: boolean;
  dropOutLikelihood?: Likelihood;
  transportationSituation?: TransportationSituation[];
  basicInfoCompleted?: boolean;
  believesFundsWouldHelp?: Agreement;
  hasOutsideSupport?: Agreement;
  otherInformation?: string;
  personalSituationCompleted?: boolean;
  hasBankAccount?: Confirmation;
  confirmBankingStatus?: boolean;
  hasBeenHomeless?: Confirmation;
  acceptsMail?: boolean;
  email?: string;
  logisticsCompleted?: boolean;
  foodChallenges?: FoodChalleges[];
  housingSituation?: HousingSituation[]; // User selection of housing statuses
  applicableEmergencyCategories?: EmergencyCategories[];
  childcareSituation?: ChildcareSituation[];
  physiologicSituationPastMonth?: PhysiologicSituationPastMonth[];
  physiologicSituation?: PhysiologicSituation[];
  physiologicChallengesFrequency?: PhysiologicChallengeFrequency;
  sleepingSituation?: SleepingSituation[];
  learningSituation?: LearningSituation[];
  filedFafsa?: boolean;
  receivedFinancialAid?: boolean;
  dacaEligible?: boolean;
  studentId?: string;
  studentId2?: string;
  foodPersistence?: Frequency;
  unbalancedMeals?: Frequency;
  hasSkippedMealsInPastMonth?: Confirmation;
  skippedMealsInPastMonth?: number;
  requestedAmount?: number;
  affirmation?: boolean;
  documents?: { all: string[] };
  applicantStatus?: string;
  receivingProgramBenefits?: string;
}
